import React, { useState } from 'react';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import blogimg1 from '../../assets/tracker-assets/child1.png';
import blogimg2 from '../../assets/tracker-assets/child2.png';
import blogimg3 from '../../assets/tracker-assets/child3.png';
import { Link } from 'react-router-dom';
import Slider, { Range } from 'rc-slider';
import { TextField } from '@material-ui/core';
import 'rc-slider/assets/index.css';
import './Blogs.css';
const blogList = [{
	image: blogimg1,
	heading: 'U.K.G Child Checkup at School...',
	date: 'Oct 29, 2020 | Bloosamberg, Castlebug',
	content: 'Cursbitur aliquet quam id dual blancias. estibulum ants ipsum aperiam sed eli apsium arrel due...',
	action: 'Read More'
}, 
{
	image: blogimg2,	
	heading: 'U.K.G Child School Activities...',
	date: 'Sept 01, 2020 | Bloosamberg, Castlebug',
	content: 'The quick brown fox jumps over the lazy little dog. The quick brown fox jumps over the lazy little dog. ',
	action: 'Read More'
},
{
	image: blogimg3,	
	heading: 'U.K.G Child School Activities...',
	date: 'Sept 01, 2020 | Bloosamberg, Castlebug',
	content: 'The quick brown fox jumps over the lazy little dog. The quick brown fox jumps over the lazy little dog. ',
	action: 'Read More'
}
];

const Blogs = (props) => {
	const { blogToken } = props;
	return (
		<div className='blog-container'>
			<Navbar />
			<div className='container'>
				<ul id="social_side_links">
					<li><a href="https://facebook.com" target="_blank" className="fb">
						<i class="fab fa-facebook-f"></i></a></li>
					<li><a href="https://twitter.com" target="_blank" className="tw">
						<i class="fab fa-twitter"></i></a></li>
					<li><a href="https://linkedin.com" target="_blank" className="ln">
						<i class="fab fa-linkedin-in"></i></a></li>
					<li><a href="https://linkedin.com" target="_blank" className="pr">
						<i class="fab fa-pinterest-p"></i></a></li>
				</ul>
				<div>
					<div className="blog-heading">
						<div className="row">
							<div className="col s12">
								<h4>Detoxa Blogs </h4>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col m5 s12">
							<div className="blog-bg">
								<h6>Proin eget tortor risus.</h6>
								<p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit consectetur ad deserunt asperiores delectus aperiam recusandae animi minus. </p>
								<div className="blog-readmore">Read More</div>
							</div>
						</div>
						<div className="col m7 s12">
							<div className="row blog-list">
								<div className="col m4 s12">
									<div className="bloglistimg"></div>
								</div>
								<div className="col m8 s12">
									<h6>Vestibulum ants ipsum primis</h6>
									<div className="date">Oct 29, 2020 | Bloosamberg, Castlebug</div>
									<p>Vestibulum ants ipsum primis deserunt asperiores delectus Domenec wait apsium minus still...</p>
								</div>
							</div>
							<div className="row blog-list">
								<div className="col m4 s12">
									<div className="bloglistimg"></div>
								</div>
								<div className="col m8 s12">
									<h6>Cras ulcricies liguls sed magna</h6>
									<div className="date">Oct 29, 2020 | Bloosamberg, Castlebug</div>
									<p> Cras ulcricies liguls sed magna declum sed Domenec wait apsium minus still...</p>
								</div>
							</div>
							<div className="row blog-list">
								<div className="col m4 s12">
									<div className="bloglistimg"></div>
								</div>
								<div className="col m8 s12">
									<h6>Cursbitur aliquet quam</h6>
									<div className="date">Oct 29, 2019 | Bloosamberg, Castlebug</div>
									<p>Cursbitur aliquet quam id dual blancias. estibulum ants ipsum aperiam sed eli apsium arrel due...</p>
								</div>
							</div>

						</div>
					</div>
				</div>

				{/* <div class="row">
					<div class="col s12 m4">
						<div class="card blog-card">
							<div class="card-image">
								<img src={cardImage} alt="card-blog" />

							</div>
							<div class="card-content">
								<h6>Cras ulcricies liguls sed magna</h6>
								<div className="date">Oct 29, 2020 | Bloosamberg, Castlebug</div>
								<p>Cursbitur aliquet quam id dual blancias. estibulum ants ipsum aperiam sed eli apsium arrel due...</p>
							</div>
							<div class="card-action">
								<a href="#">read more</a>
							</div>
						</div>
					</div>
					<div class="col s12 m4">
						<div class="card blog-card">
							<div class="card-image">
								<img src={cardImage} alt="card-blog" />

							</div>
							<div class="card-content">
								<h6>Cras ulcricies liguls sed magna</h6>
								<div className="date">Oct 29, 2020 | Bloosamberg, Castlebug</div>
								<p>Cursbitur aliquet quam id dual blancias. estibulum ants ipsum aperiam sed eli apsium arrel due...</p>
							</div>
							<div class="card-action">
								<a href="#">read more</a>
							</div>
						</div>
					</div>
					<div class="col s12 m4">
						<div class="card blog-card">
							<div class="card-image">
								<img src={cardImage} alt="card-blog" />
							</div>
							<div class="card-content">
								<h6>Cras ulcricies liguls sed magna</h6>
								<div className="date">Oct 29, 2020 | Bloosamberg, Castlebug</div>
								<p>Cursbitur aliquet quam id dual blancias. estibulum ants ipsum aperiam sed eli apsium arrel due...</p>
							</div>
							<div class="card-action">
								<a href="#">read more</a>
							</div>
						</div>
					</div>
				</div> */}


				<div className="row">

					<div className='bloglist'>
						{blogList.map((aBlog) => (
							<BlogCard {...aBlog} />
						))}
					</div>
					<br />
					<div className='bloglist'>
						{blogList.map((aBlog) => (
							<BlogCard {...aBlog} />
						))}
					</div>

				</div>
				
			</div>


			<Footer />
		</div>
	);
};

const BlogCard = (props) => {
	const { image, content, heading, date, action } = props;
	return (
		<div className='single-blog'>
			<div class="col s12 m4">
				<div class="card blog-card">
					<div class="card-image" id="blog-zoom">
						<img src={image} />
					</div>
					<div class="card-content">
						<h6>{heading}</h6>
						<div className="date">{date}</div>
						<p>{content}</p>
					</div>
					<div class="card-action">
						<Link to="blogs/bloglist">{action}</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Blogs;
